<template>
  <div class="custom-control custom-checkbox mx-2" style="display: inline-block">
    <input class="form-check-input" 
    type="checkbox" 
    v-model="selectGroup.value"
    v-on:change="changeSelect(selectGroup)"
    :id="'select-' + selectGroup.key">
    <label class="form-check-label" :for="'select-' + selectGroup.key">{{selectGroup.name}}</label>
  </div>
</template>

<script>
/*
  selectGroup: {
    key: '',
    value: true/false,
    name: ''
  }
*/

function changeSelect (selectGroup, event) {
  let query = {}
  query[selectGroup.key] = selectGroup.value ? String(selectGroup.internalValue) : '-' + String(selectGroup.internalValue)
  this.updateQuery(query)
}

function initSearch () {
  // 根据url里面的参数， 初始化每一个按钮的显示
  this.selectGroup = this.pSelectGroup || []

  let query = this.$route.query
  for (let key in query) {
    // 查找selects
    if (this.selectGroup.key === key) {
      this.selectGroup.value = !query[key].startsWith('-')
    }
  }
}

function updateQuery (object) {
  let query = Object.assign({}, this.$route.query)

  // remove query
  for (let key in object) {
    let value = object[key]
    if (value === '' || value === 'all') {
      delete query[key]
    } else {
      query[key] = value
    }
  }

  query.page = 1
  this.$router.push({query: query})
}

export default {
  name: 'search',
  data () {
    return {
      selectGroup: {}
    }
  },
  props: ['pSelectGroup', 'size'],
  methods: {
    changeSelect,
    initSearch,
    updateQuery
  },
  mounted () {
    this.initSearch()
  }
}
</script>